/** Deep partial of translation keys applied when the organization country is US. */
export const US_GLOSSARY_EN = {
  nav: {
    projects: "Jobs",
    diary: "Daily log",
    team: "Work area",
    serviceFrontModels: "Work area models",
    workers: "Crew",
    occurrences: "Issues",
    clientBudgets: "Proposals",
    budget: "Job budget",
    partners: "Customers & vendors",
  },
  onboarding: {
    cnpj: "EIN",
    cnpjPlaceholder: "12-3456789",
    cnpjInvalid: "Enter a valid EIN",
    legalNamePlaceholder: "Acme Construction LLC",
    companyDescription: "This identifies your company in KonstruLog.",
  },
  settings: {
    organization: {
      technicalResponsibleRegistry: "PE license",
      technicalResponsibleRegistryPlaceholder: "License number",
      phonePlaceholder: "(555) 123-4567",
      commercialEmailPlaceholder: "office@company.com",
    },
  },
  partners: {
    zipCodeLabel: "ZIP",
    zipCodePlaceholder: "12345",
    zipInvalid: "Enter a valid ZIP code.",
    neighborhoodLabel: "Neighborhood",
    cpfLabel: "SSN",
    cpfPlaceholder: "123-45-6789",
    cpfInvalid: "Enter a valid SSN.",
    rgLabel: "Driver's license",
    cnpjLabel: "EIN",
    paymentDataAgencyLabel: "Routing number",
  },
  projectDiaryEntries: {
    colProjectServiceFronts: "Work areas",
    colOccurrences: "Issues",
  },
};

/**
 * Portuguese UI on a US company: Portuguese chrome, US legal names (EIN, SSN, ZIP).
 * Do not inject English menu words (Jobs, Proposals) into pt-BR.
 */
export const US_GLOSSARY_PT_BR = {
  nav: {
    partners: "Clientes e fornecedores",
  },
  onboarding: {
    cnpj: "EIN",
    cnpjPlaceholder: "12-3456789",
    cnpjInvalid: "Informe um EIN válido",
    legalNamePlaceholder: "Acme Construction LLC",
  },
  settings: {
    organization: {
      technicalResponsibleRegistry: "Licença PE",
      technicalResponsibleRegistryPlaceholder: "Número da licença",
    },
  },
  partners: {
    zipCodeLabel: "ZIP",
    zipCodePlaceholder: "12345",
    zipInvalid: "Informe um ZIP válido.",
    cpfLabel: "SSN",
    cpfPlaceholder: "123-45-6789",
    cpfInvalid: "Informe um SSN válido.",
    rgLabel: "Carteira de motorista",
    cnpjLabel: "EIN",
    paymentDataAgencyLabel: "Routing number",
  },
};
